@let isAnalysis = (isAnalysis$ | async) ?? false;
@let isInspection = (isInspection$ | async) ?? false;
@let isInspectionOrAnalysis = (isInspectionOrAnalysis$ | async) ?? false;
@let isInspectionOrSetup = (isInspectionOrSetup$ | async) ?? false;

<evi-numeric-field
  label="Gain"
  [readOnly]="isInspectionOrAnalysis"
  [parameter]="utSettingsModel?.generalGain"
  data-testid="gain"
  [incrementMode]="FIELD_INCREMENT_MODE"
  [delayTime]="500"
></evi-numeric-field>

@if (isAnalysis) {
  <evi-numeric-field
    label="Analysis Gain"
    [parameter]="utSettingsModel?.softGain"
    [displayPlusSign]="true"
    data-testid="analysis-gain"
    [incrementMode]="FIELD_INCREMENT_MODE"
    [delayTime]="500"
    [readOnly]="!featureFlagAnalysis"
  ></evi-numeric-field>
}

@if (isInspectionOrSetup) {
  <evi-numeric-field
    label="Start"
    [readOnly]="isInspection"
    [parameter]="utSettingsModel?.beamsModel.ascanStart"
    data-testid="start"
  ></evi-numeric-field>

  <evi-numeric-field
    label="Range"
    [readOnly]="isInspection"
    [parameter]="utSettingsModel?.beamsModel.ascanLength"
    data-testid="range"
  ></evi-numeric-field>
}
